import Box from "ds/components/Box";
import Badge from "ds/components/Badge";

import { getDoraTimeUnit } from "../helpers";
import DoraTimeAverage from "../components/DoraTimeAverage";
import DoraEmpty from "../components/Empty";
import DoraTimeRange from "../components/DoraTimeRange";
import { getDoraGrade } from "../getDoraGrade";
import useDoraChartType from "../useChartType";
import useDoraLeadTimeChangesAverage from "./useAverage";
import useDoraLeadTimeChangesRange from "./useRange";
import { CHART_TYPE_STORAGE_KEY, LEAD_TIME_THRESHOLDS } from "./constants";

const DashboardWidgetsDoraLeadTimeChanges = () => {
  const { averageSeconds, isLoading: isAverageLoading } = useDoraLeadTimeChangesAverage();
  const { range, hasRuns } = useDoraLeadTimeChangesRange();
  const { chartType } = useDoraChartType(CHART_TYPE_STORAGE_KEY);

  const hasData = hasRuns && !!range?.length;

  if (!hasData) {
    return (
      <DoraEmpty
        title="No data available"
        caption="Lead time is calculated from PR merge commits with tracked runs"
      />
    );
  }

  const unit = getDoraTimeUnit(averageSeconds ?? 0);
  const grade = getDoraGrade(averageSeconds ?? 0, LEAD_TIME_THRESHOLDS);

  return (
    <Box direction="column" gap="x-large" fullWidth>
      <DoraTimeAverage
        averageSeconds={averageSeconds ?? 0}
        isLoading={isAverageLoading}
        badge={grade && <Badge variant={grade.badgeVariant} type="weak" text={grade.label} />}
      />
      <DoraTimeRange
        range={range}
        unit={unit}
        chartType={chartType}
        gradeThresholds={LEAD_TIME_THRESHOLDS}
      />
    </Box>
  );
};

export default DashboardWidgetsDoraLeadTimeChanges;
